export default "assets/images/icons/facebook_old-d319109b.svg";